import './stage.scss';

class Stage {
    constructor (element) {
        this.$stage = element;
        this.$content = this.$stage.querySelector('[data-stage="content"]');
        this.$pauseButton = this.$stage.querySelector('[data-media="pause"]');
        this.$playButton = this.$stage.querySelector('[data-media="play"]');
        this.$stageContainer = this.$stage.querySelector('.stage__container');
        this.stageHide = this.$stage.dataset.stageHide;
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        if (this.$pauseButton) {
            this.$pauseButton.addEventListener('click', () => {
                this.$stageContainer.classList.add('stage__container--deactive');
            });
        }

        if (this.$playButton) {
            this.$playButton.addEventListener('click', () => {
                this.$stageContainer.classList.remove('stage__container--deactive');
            });
        }

        if (this.$content && this.stageHide) {
            if (this.stageHide !== 'immediately') {
                setTimeout(() => {
                    this.$content.classList.add('stage__content--hidden');
                }, (parseInt(this.stageHide) * 1000));
            } else {
                this.$content.classList.add('stage__content--hidden');
            }

            window.addEventListener('video.play', () => {
                this.$content.classList.add('stage__content--hidden');
            });

            window.addEventListener('video.pause', () => {
                setTimeout(() => {
                    this.$content.classList.remove('stage__content--hidden');
                }, 200);
            });
        }
    }
}

export { Stage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$stages = $context.querySelectorAll('[data-stage="root"]');
        $$stages.forEach(($stage) => {
            const stage = new Stage($stage);
            stage.initialize();
        });
    }
});
